import React, { useEffect, useState } from "react";
import { Form, message } from "antd";
import { useQueryState } from "nuqs";
import { useMessageApi } from "../../../provider/AntdNotification";
import { usePageDetail, usePageSave } from "../../../hooks/api/page/hooks";
import TabsContain from "../../components/reuseComp/TabsContain";
// import Banner from "@src/views/components/sections/Banner";
import AboutUs from "./aboutUs";
import WhatWeStandFor from "./whatWeStandFor";
import { getSingleImageUrl } from "../../../lib/utils";
import { IPageDetailPayload } from "../../../types/api/page"
import Banner from "../../components/sections/Banner";
import { SectionField } from "../home/HomeTabs";
import WhatSetsUsApart from "../home/whatSetsUsApart";
import WhoWeAre from "./WhoWeAre";
import GlobalReach from "./globalReach";

const AboutTabs: React.FC<{
  setBreadcrumb: React.Dispatch<React.SetStateAction<string>>;
}> = ({ setBreadcrumb }) => {
  const message = useMessageApi();
  const [tab, setTab] = useQueryState("tab");
  const activeTab = tab || "Banner";
  const [isEditing, setIsEditing] = useState(false);
  const [form] = Form.useForm();
  const [pageData, setPageData] = useState<any>(null);

  const { data } = usePageDetail("ABOUT");
  const { mutate: updatePage, isPending } = usePageSave({});
  const [reviewMode, setReviewMode] = useState<"list" | "add" | "edit">("list");
  const [editingReviewIndex, setEditingReviewIndex] = useState<number | null>(
    null,
  );

  useEffect(() => {
    if (data?.data) setPageData(data.data);
  }, [data]);

  const handleChangeTab = (section: string) => {
    setTab(section);
    setIsEditing(false);
    setBreadcrumb(section);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();

      const payload: IPageDetailPayload & { _id?: string } = {
        _id: pageData?._id,
        pageType: "ABOUT",
        about: {
          banner: {
            heading:
              values.banner?.heading ?? pageData?.about?.banner?.heading ?? "",
            image: getSingleImageUrl(
              values.banner?.image ?? pageData?.about?.banner?.image
            ),
          },

          overview: {
            heading:
              values.overview?.heading ??
              pageData?.about?.overview?.heading ??
              "",
            subtext:
              values.overview?.subtext ??
              pageData?.about?.overview?.subtext ??
              [],
          },

          whoWeAre: {
            heading:
              values.whoWeAre?.heading ??
              pageData?.about?.whoWeAre?.heading ??
              "",
            subtext:
              values.whoWeAre?.subtext ??
              pageData?.about?.whoWeAre?.subtext ??
              "",
            text: (values.whoWeAre?.text ?? pageData?.about?.whoWeAre?.text ?? [])?.map(
              (item: any) => ({
                title: item?.title ?? "",
                description: item?.description ?? "",
              })
            ),
          },

          globalReach: {
            heading:
              values.globalReach?.heading ??
              pageData?.about?.globalReach?.heading ??
              "",
            subtext:
              values.globalReach?.subtext ??
              pageData?.about?.globalReach?.subtext ??
              "",
            image: getSingleImageUrl(
              values.globalReach?.image ??
              pageData?.about?.globalReach?.image
            ),
          },

          whatWeStandFor: pageData?.about?.whatWeStandFor ?? {
            heading: "",
            subtext: "",
            image: "",
            content: [],
          },
        },
      };

      if (activeTab === "What We Stand For") {
        const existingContent =
          pageData?.about?.whatWeStandFor?.content || [];

        let updatedContent = existingContent;

        if (reviewMode === "add") {
          updatedContent = [
            ...existingContent,
            ...(values.whatWeStandFor?.content || []),
          ];
        } else if (reviewMode === "edit" && editingReviewIndex !== null) {
          updatedContent = existingContent.map((item: any, idx: number) =>
            idx === editingReviewIndex
              ? { ...item, ...values.whatWeStandFor.content[0] }
              : item
          );
        }

        payload.about.whatWeStandFor = {
          heading:
            values.whatWeStandFor?.heading ??
            pageData?.about?.whatWeStandFor?.heading ??
            "",
          subtext:
            values.whatWeStandFor?.subtext ??
            pageData?.about?.whatWeStandFor?.subtext ??
            "",
          image: getSingleImageUrl(
            values.whatWeStandFor?.image ??
            pageData?.about?.whatWeStandFor?.image
          ),
          content: updatedContent,
        };
      }

      updatePage(payload, {
        onSuccess: (res) => {
          message.success("Page updated successfully");
          setPageData(res.data);
          setIsEditing(false);
          setReviewMode("list");
          setEditingReviewIndex(null);
        },
        onError: () => {
          message.error("Failed to update page");
        },
      });
    } catch (error) {
      console.log("❌ Validation failed:", error);
    }
  };

  const handleDelete = (index: number, field: SectionField) => {
    if (!pageData) return;

    let payload: IPageDetailPayload;

    if (field === "whatWeStandFor") {
      const current = pageData.about?.whatWeStandFor?.content ?? [];
      const updated = current.filter(
        (_item: { title: string; description: string }, i: number) =>
          i !== index,
      );

      payload = {
        ...pageData,
        about: {
          ...pageData.about,
          whatWeStandFor: {
            ...pageData.about.whatWeStandFor,
            content: updated,
          },
        },
      };
    } else {
      payload = { ...pageData };
    }

    updatePage(payload, {
      onSuccess: () => {
        message.success("Data deleted successfully");
        setPageData(payload);
        setReviewMode("list");
        setEditingReviewIndex(null);
      },
      onError: () => message.error("Failed to delete"),
    });
  };

  const sections = ["Banner", "About Overview", "Who We Are", "Global Reach", "What We Stand For",];

  return (
    <div>
      <TabsContain
        sections={sections}
        handleChangeTab={handleChangeTab}
        activeTab={activeTab}
      />

      {activeTab === "Banner" && (
        <Banner
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleCancel={handleCancel}
          handleSave={handleSave}
          form={form}
          bannerData={pageData?.about?.banner}
          loading={isPending}
        />
      )}

      {activeTab === "About Overview" && (
        <AboutUs
          form={form}
          aboutData={pageData?.about}
          loading={isPending}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleCancel={handleCancel}
          handleSave={handleSave}
        />
      )}

      {activeTab === "Who We Are" && (
        <WhoWeAre
          whoWeAre={pageData?.about?.whoWeAre}
          form={form}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleSave={handleSave}
          handleCancel={handleCancel}
          loading={isPending}
        />
      )}

      {activeTab === "Global Reach" && (
        <GlobalReach
          globalReach={pageData?.about?.globalReach}
          form={form}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleSave={handleSave}
          handleCancel={handleCancel}
          loading={isPending}
        />
      )}

      {activeTab === "What We Stand For" && (
        <WhatWeStandFor
          whatWeStandFor={pageData?.about?.whatWeStandFor}
          form={form}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleSave={handleSave}
          handleCancel={handleCancel}
          loading={isPending}
          onDelete={handleDelete}
          mode={reviewMode}
          setMode={setReviewMode}
          editingIndex={editingReviewIndex}
          setEditingIndex={setEditingReviewIndex}
        />
      )}
    </div>
  );
};

export default AboutTabs;
